import de from './locales/de';
import en from './locales/en';

export default {
  en,
  de,
};
